import { MobileOrderFg } from "types";
const ORDER_CANCEL_LAYER_TYPES = {
  CID: "order_end_accept_reject",
  BAEMIN: "baemin_order_cancel",
  YGY: "ygy_order_cancel",
  NAVER: "end_order_cancel_naver",
  STANDARD: "end_order_cancel",
  REFUND: "refund_order_cancel",
  NAVERBOOKING: "end_order_cancel_naver",
  NAVERCONNECT: "end_order_cancel_naver",
};

const LAYER_TYPE_MAP = new Map([
  [MobileOrderFg.NAVER, ORDER_CANCEL_LAYER_TYPES.NAVER],
  [MobileOrderFg.PANDA_SELF_DELIVERY, ORDER_CANCEL_LAYER_TYPES.STANDARD],
  [MobileOrderFg.HUNGRY_PANDA, ORDER_CANCEL_LAYER_TYPES.STANDARD],
  [MobileOrderFg.MUKKEBI, ORDER_CANCEL_LAYER_TYPES.STANDARD],
  [MobileOrderFg.OLTTEA_AH, ORDER_CANCEL_LAYER_TYPES.REFUND],
  [MobileOrderFg.NAVER_BOOKING, ORDER_CANCEL_LAYER_TYPES.NAVERBOOKING],
  [MobileOrderFg.NAVERCONNECT, ORDER_CANCEL_LAYER_TYPES.NAVERCONNECT],
]);

// 레이어 타입 결정 로직 분리
export function cancelLayerType(mobileOrderFg: MobileOrderFg, type: string): string {
  // 우선순위에 따른 레이어 타입 결정
  if (mobileOrderFg === MobileOrderFg.CID) {
    return ORDER_CANCEL_LAYER_TYPES.CID;
  }

  if (type === "baemin") {
    return ORDER_CANCEL_LAYER_TYPES.BAEMIN;
  }

  if (type === "ygy") {
    return ORDER_CANCEL_LAYER_TYPES.YGY;
  }

  const layerType = LAYER_TYPE_MAP.get(mobileOrderFg);
  return layerType || ORDER_CANCEL_LAYER_TYPES.REFUND;
}
